export default __webpack_public_path__ + "images/0x526728dbc96689597f85ae4cd716d4f7fccbae9d.png";